import Api from "../api/Api";

export class AdminQueriesTools {

    async list() {
        const response = await Api.request({
            root: "admin-tools",
            entity: "query",
            method: "list",
            data: {}
        });
        return response.queries;
    }

    async wait(queryId) {
        const response = await Api.request({
            root: "admin-tools",
            entity: "query",
            method: "wait",
            data: { queryId }
        });
        return response.query;
    }

    async add(sql) {
        const response = await Api.request({
            root: "admin-tools",
            entity: "query",
            method: "add",
            data: { sql }
        });
        return response.query;
    }

    async execute(sql) {
        const response = await Api.request({
            root: "admin-tools",
            entity: "query",
            method: "execute",
            data: { sql }
        });
        return response.rows;
    }

    async cancel(queryId) {
        const response = await Api.request({
            root: "admin-tools",
            entity: "query",
            method: "cancel",
            data: { queryId }
        });

        return response.query;
    }
}
